<template>
    <!-- 管理员- 作业统计 -->
    <div class="personnel wrapper">
        <proTitle></proTitle>
        <el-form :inline="true" class="demo-form-inline flex-align-between" @submit.native.prevent>
            <div class="formInline-left">
                <el-date-picker size="mini" v-model="formInline.datetimerange" type="datetimerange"
                    start-placeholder="开始日期" range-separator="至" end-placeholder="结束日期" @change="filterChange"
                    :editable="false" value-format="yyyy-MM-dd HH:mm:ss" class="date-picker">
                </el-date-picker>
            </div>
            <div class="formInline-right flex-align-between">
                <el-input size="mini" v-model="formInline.search" placeholder="作业主题名称" suffix-icon="el-icon-search"
                    @input="filterChange">
                </el-input>
            </div>
            <div class="download-inline">
                <span class="export-btn csp" @click="exportFile" style="margin-right:10px">
                    <i class="export-icon"></i>导出</span>
                <span class="export-btn csp" @click="refreshData">
                    <i class="el-icon-refresh"></i>刷新数据</span>
            </div>
        </el-form>
        <div class="table_section">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="number" label="序号" width="80" align="center" type="index" fixed
                    :index="indexMethod">
                </el-table-column>
                <el-table-column prop="themeName" label="作业主题" align="center" fixed>
                </el-table-column>
                <el-table-column prop="questName" label="作业名称" align="center" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="commitCount" label="提交作业人数" align="center" width="180">
                </el-table-column>
            </el-table>
            <pagination :total="pages.total" :page.sync="pages.currentPage" :limit.sync="pages.pageSize"
                :pageSizes="[10,20,30]" @pagination="handlePageChange">
            </pagination>
        </div>
    </div>

</template>

<script>
    import upload from './components/upload-file.vue';
    import {
        cloneDeep
    } from 'lodash/lang'

    export default {
        components: {
            upload
        },
        data() {
            return {
                tableData: [],
                pages: { //分页
                    currentPage: 1,
                    pageSize: 10,
                    total: 0,
                },
                formInline: {
                    datetimerange: '',
                    search: '',
                },
                loadingInstance: '',
                intervalId: null
            };
        },
        methods: {
            indexMethod(index) {
                return this.pages.currentPage > 1 ?
                    (this.pages.pageSize * (this.pages.currentPage - 1)) + index + 1 :
                    index + 1
            },
            // 翻页
            handlePageChange(data) {
                this.pages.currentPage = data.pageIndex
                this.pages.pageSize = data.pageSize
                this.getWorkStatisticInfo();
            },
            filterChange() {
                this.pages.currentPage = 1;
                this.getWorkStatisticInfo();
            },
            refreshData() {
                this.formInline.datetimerange = '';
                this.formInline.search = '';
                this.pages.currentPage = 1;
                this.loadingInstance = this.$loading({
                    // fullscreen:false,
                    lock: true,
                    text: '数据刷新中...',
                    spinner: 'el-icon-loading',
                });
                let data = {
                    projectId: this.$store.state.user.currentProject.id
                }
                this.$Api.Project.sendRefresh(data)
                    .then(res => {
                        console.log('发送刷新成功', res);
                        this.getWorkStatisticInfo();
                    })
                    .catch(err => {
                        console.log('发送刷新失败', err)
                    })
            },
            // 获取周报列表
            async getWorkStatisticInfo() {
                let params = {
                    page: this.pages.currentPage,
                    limit: this.pages.pageSize,
                    projectId: this.$store.state.user.currentProject.id,
                }
                params.queryKeys = this.formInline.search ? this.formInline.search : null;
                params.queryStartTime = this.formInline.datetimerange ? this.formInline.datetimerange[0] : null;
                params.queryEndTime = this.formInline.datetimerange ? this.formInline.datetimerange[1] : null;
                // console.log(pramas);
                let resData = await this.$Api.Project.getWorkStatisticList(params);
                // console.log(resData.data);
                this.tableData = resData.data.records
                this.pages.total = resData.data.total
                if (this.loadingInstance) {
                    this.loadingInstance.close()
                }
            },
            async exportFile() {
                this.loadingInstance = this.$loading({
                    target: '.home-wrapper',
                    lock: true,
                    text: '正在导出中，请勿关闭页面...',
                    spinner: 'el-icon-loading',
                    // background:'rgba(0, 0, 0, 0.8)'
                });
                let data = {
                    id: this.$store.state.user.currentProject.id
                }
                let resData = await this.$Api.Project.getExportWorkUrl(data)
                console.log('导出地址结果--', resData)
                let data2 = {
                    projectId: this.$store.state.user.currentProject.id,
                    // key: resData.data,
                    userId: this.$store.state.user.userInfo.id
                }
                this.intervalId = setInterval(() => {
                    this.$Api.Project.exportWork(data2)
                        .then(res => {
                            console.log('作业导出状态--', res)
                            if (res.data.state) {
                                clearInterval(this.intervalId) // 清除定时器
                                this.loadingInstance.close() // 关闭loading状态
                                let pramas = {
                                    identifier: res.data.identity,
                                }
                                this.$Api.Home.getDownloadUrl(pramas)
                                    .then(res=>{
                                        console.log('res:',res)
                                        window.location.href = res.data.url
                                        // window.open()
                                    })
                                    .catch(err=>{
                                        console.log('err:',err)
                                    })
                                // let resData = await this.$Api.Home.getDownloadUrl(pramas);
                                // // console.log('地址', resData);
                                // if (resData.data.url) {
                                //     window.location.href = resData.data.url;
                                // }
                            }
                            // if (res.code == 200) {
                            //     window.location.href =
                            //         `${window.ApiServer}/quest/project/download/export?
                            //    projectId=${this.$store.state.user.currentProject.id}&key=${resData.data}&userId=${this.$store.state.user.userInfo.id}`
                            //     clearInterval(this.intervalId) // 清除定时器
                            //     this.loadingInstance.close() // 关闭loading状态
                            // }
                        })
                        .catch(err => {
                            console.log('作业导出失败，清除定时器--', err)
                            clearInterval(this.intervalId)
                        })
                }, 5000)
            },
            // 查询刷新状态
            async checkRefresh() {
                let data = {
                    projectId: this.$store.state.user.currentProject.id
                }
                let resData = await this.$Api.Project.checkRefresh(data)
                console.log('查询刷新状态', resData);
                if (resData.msg = "未刷新或刷新完成") {
                    console.log('刷新完成关闭loading');
                    if (this.loadingInstance) {
                        this.loadingInstance.close()
                    }
                } else {
                    console.log('正在刷新显示loading');
                    this.loadingInstance = this.$loading({
                        lock: true,
                        text: '数据刷新中...',
                        spinner: 'el-icon-loading',
                    });
                }
            }
        },
        mounted() {
            this.getWorkStatisticInfo();
            this.checkRefresh()
        },
    }
</script>

<style lang="less" scoped>
    @import "../manage/less/table.less";

    .personnel {
        padding: 20px 25px;
        box-sizing: border-box;

        .demo-form-inline {
            margin: 15px 0;

            .date-picker {
                width: 320px;
            }

            @media screen and (min-width:1250px) {
                margin: 20px 0;

                .date-picker {
                    width: 400px;
                }
            }
        }

        .download-inline {
            .export-btn {
                color: #595959;
            }

            .export-icon {
                display: inline-block;
                background-image: url("~@/assets/images/admin/export.png");
                background-size: 100% 100%;
                width: 17px;
                height: 16px;
                margin-right: 8px;
                vertical-align: -2px;
            }
        }

        .table_section {
            /deep/.el-table th {
                &>.cell {
                    white-space: pre-line;
                }
            }
        }
    }
</style>